/* Fund-enabled site gate. Returns { enabled, sites, loading }.
 *
 * `enabled` is true iff the current user has AT LEAST ONE site with
 * `fund_enabled=true`, OR is Owner/Head (who see everything).
 * `sites` is the array of fund-enabled sites the caller can operate on.
 *
 * Used to gate the Fund nav entries and page redirects — never a security
 * boundary (the backend enforces auth + flag on every write).
 */
import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function useFundEnabled() {
    const { user } = useAuth();
    const [state, setState] = useState({ enabled: false, sites: [], loading: true });

    useEffect(() => {
        let cancelled = false;
        async function load() {
            if (!user) return;
            const role = user.effective_role || user.role;
            if (role === "CLIENT") { setState({ enabled: false, sites: [], loading: false }); return; }
            try {
                const { data } = await api.get("/sites");
                const enabledSites = (data || []).filter((s) => s.fund_enabled);
                if (cancelled) return;
                setState({ enabled: enabledSites.length > 0, sites: enabledSites, loading: false });
            } catch {
                if (!cancelled) setState({ enabled: false, sites: [], loading: false });
            }
        }
        load();
        return () => { cancelled = true; };
    }, [user]);
    return state;
}
